import { render, staticRenderFns } from "./detailFull.vue?vue&type=template&id=23f6b910&"
import script from "./detailFull.vue?vue&type=script&lang=ts&"
export * from "./detailFull.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports